import { Box, Flex, SimpleGrid, Text } from '@chakra-ui/react';
import {
  PageHeader,
  MetaTags,
  PageToolbar,
  TeamMenu,
  DateFilter,
  useDashboardStore,
  AI_IMPACT_CHART_KEYS,
  ZeroStatePage,
} from '@devd-client/devd/components';
import { FC } from 'react';
import { AuthActionTypes, getUser } from '@devd-client/devd/auth';
import { useAiImpactDashboard } from '../hooks/useAiImpactDashboard';
import { AiImpactMetricCard } from '../components/AiImpact/AiImpactMetricCard';
import { useAiAdoptionPage } from '../api';

export const AiImpact: FC = () => {
  const { selectedTeam, setSelectedTeam, appState, dispatch } =
    useAiImpactDashboard();
  const { selected } = useDashboardStore();
  const { data } = useAiAdoptionPage();

  return (
    <>
      <MetaTags title="AI Impact | Dashboard | Devdynamics" />

      {data && data?.dto?.enabled ? (
        <Box display={'flex'} flexDirection={'column'} width={'100%'}>
          <Box>
            <PageHeader
              headingText={'AI Impact'}
              mb={'10px'}
              tooltip="Measure and analyze the impact of AI tools on your development process. Track productivity improvements, code quality metrics, and team efficiency gains from AI-assisted development. Use these insights to quantify ROI and optimize AI tool adoption strategies."
            />
            <PageToolbar
              leftComp={
                <Flex align="flex-end" gap={3}>
                  <TeamMenu
                    selectedTeam={selectedTeam}
                    handleSelectedTeam={setSelectedTeam}
                    AuthActionTypes={AuthActionTypes}
                    getUser={getUser}
                    appState={appState}
                    dispatch={dispatch}
                  />
                </Flex>
              }
              rightComp={
                <DateFilter
                  getUser={getUser}
                  appState={appState}
                  dispatch={dispatch}
                  AuthActionTypes={AuthActionTypes}
                />
              }
            />

            {/* Metrics Grid */}
            <Box mt={4}>
              <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={6}>
                {AI_IMPACT_CHART_KEYS.map((metric) => (
                  <AiImpactMetricCard
                    key={metric}
                    metricKey={metric}
                    teamId={selectedTeam.value}
                    startDate={selected?.startDate || ''}
                    endDate={selected?.endDate || ''}
                    sprintId={selected?.sprintId || ''}
                    breakdown=""
                  />
                ))}
              </SimpleGrid>
            </Box>
          </Box>
        </Box>
      ) : (
        <ZeroStatePage
          data={data?.dto}
          featureAlert={data?.featureEnable === false ? true : false}
        />
      )}
    </>
  );
};

export default AiImpact;
